export enum SalesRankingIndicatorsOrderingEnum {
    USER = 'USER',
    TOTAL_SALES = 'TOTAL_SALES',
    SALE_VALUE = 'SALE_VALUE',
    SALE_VALUE_AVERAGE = 'SALE_VALUE_AVERAGE',
    PACKAGES_PER_SALE = 'PACKAGES_PER_SALE',
    AVERAGE_DISCOUNT = 'AVERAGE_DISCOUNT',

}
